import { render, staticRenderFns } from "./EllipseIcon.vue?vue&type=template&id=81adc1ec&"
import script from "./EllipseIcon.vue?vue&type=script&lang=js&"
export * from "./EllipseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports